import Cookies from "js-cookie";
import * as Sentry from "@sentry/browser";

export const LocalStorage = {
  initStorage(storageKey, defaultValue = []) {
    return {
      storageKey,
      defaultValue,

      get() {
        try {
          const storedValue = localStorage.getItem(this.storageKey);
          return storedValue ? JSON.parse(storedValue) : this.defaultValue;
        } catch (error) {
          Sentry.captureException(`Error retrieving from localStorage (${this.storageKey}):`, error);
          return this.defaultValue;
        }
      },

      set(value, syncCookies = false, expirationDays = 365) {
        try {
          const jsonValue = JSON.stringify(value);
          localStorage.setItem(this.storageKey, jsonValue);

          if (syncCookies) {
            Cookies.set(this.storageKey, jsonValue, { expires: expirationDays });
          }
        } catch (error) {
          Sentry.captureException(`Error saving to localStorage (${this.storageKey}):`, error);
        }
      },

      clear() {
        try {
          localStorage.removeItem(this.storageKey);

          if (Cookies.get(this.storageKey)) {
            Cookies.remove(this.storageKey);
          }
        } catch (error) {
          Sentry.captureException(`Error clearing localStorage (${this.storageKey}):`, error);
        }
      }
    };
  }
};
